export default "__VITE_ASSET__DlE2ZGaq__"